import type { AppearanceStyleSet } from '@setplex/tria-api'
import type {
  ApiAnswerAppearanceDto,
  AppearanceDto,
} from '@setplex/wbs-api-types'
import type { ApiType } from '../../../shared/schemas'
import * as v from 'valibot'
import { response } from '../../../shared/schemas'
import { StyleSchema, FALLBACK_STYLE } from './styles'
import { ModulesSchema } from './modules'

export const AppearanceSchema = v.object({
  mainStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  additionalStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  backgroundStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  secondaryStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  modules: v.nullish(ModulesSchema, undefined),
}) satisfies ApiType<AppearanceDto, AppearanceStyleSet>

export const AppearanceResponseSchema = response(
  AppearanceSchema
) satisfies ApiType<ApiAnswerAppearanceDto, any>
